module.exports = __webpack_public_path__ + "img/Z60Q_10.6583faeb.jpg";